<template>
  <div>
    <div class="mobile-nav">
      <mobilenav />
    </div>
    <div class="columns">
      <div class="column side-nav">
        <sidebar />
      </div>
      <div class="column is-10">
        <navbar />
        <notification />
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from "@/components/sidebar/sidebar.vue";
import navbar from "@/components/Navbar/navbar.vue";
import notification from "@/components/Notification/index.vue"
import mobilenav from "@/components/Navbar/mobilenav.vue";

export default {
  name: "Pushnotification",
  components: {
    sidebar,
    navbar,
    notification,
    mobilenav,
  },
};
</script>

<style scoped>
.mobile-nav{
  display: none;
}
@media screen and (max-width: 768px) {
  .mobile-nav {
    display: block;
  }
  .side-nav{
    display: none;
  }
}
</style>
